import { reactive } from 'vue'
import type { VoiceSession, VoiceFragment, SessionAnalysis } from '../types'

export interface VoiceNotesState {
  sessions: VoiceSession[]
  currentSession: VoiceSession | null
  fragments: VoiceFragment[]
  analysis: SessionAnalysis | null
  isLoading: boolean
  isLoadingFragments: boolean
  isLoadingAnalysis: boolean
  isAnalyzing: boolean
  error: string | null
}

export const getInitialState = (): VoiceNotesState => ({
  sessions: [],
  currentSession: null,
  fragments: [],
  analysis: null,
  isLoading: false,
  isLoadingFragments: false,
  isLoadingAnalysis: false,
  isAnalyzing: false,
  error: null,
})

export const createState = (): VoiceNotesState => {
  return reactive(getInitialState())
}

export const resetState = (state: VoiceNotesState): void => {
  const initial = getInitialState()
  state.sessions = initial.sessions
  state.currentSession = initial.currentSession
  state.fragments = initial.fragments
  state.analysis = initial.analysis
  state.isLoading = initial.isLoading
  state.isLoadingFragments = initial.isLoadingFragments
  state.isLoadingAnalysis = initial.isLoadingAnalysis
  state.isAnalyzing = initial.isAnalyzing
  state.error = initial.error
}
